<script>
import { mapActions, mapGetters } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';
import PopupCalculator from '@/components/Popups/Calculator';
import VSelect from '@/components/Common/VSelect';

export default {

  components: {
    PopupCalculator,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
    props: {
    title: {
      type: String,
      default: 'Калькулятор выкупа авто',
    },
    subject: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      brand: null,
      model: null,
      year: null,
      generation: null,
      title: this.title,
    };
  },
  setup() {
    const schema = Yup.object().shape({
      brand: Yup.mixed().nullable(false).required(),
      model: Yup.mixed().nullable(false).required(),
      year: Yup.mixed().nullable(false).required(),
      generation: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
    };
  },
  computed: {
    ...mapGetters({
      brands: 'Vikup/brands',
      models: 'Vikup/models',
      years: 'Vikup/years',
      generations: 'Vikup/generations',
      fetching: 'Vikup/fetching',
    }),
  },
  watch: {
    models() {
      if (this.models.length === 1) {
        this.model = this.models[0];
      }
    },
    years() {
      if (this.years.length === 1) {
        this.year = this.years[0];
      }
    },
    generations() {
      if (this.generations.length === 1) {
        this.generation = this.generations[0];
      }
    },
    brand() {
      if (this.brand) {
        this.loadModels({ brand: this.brand?.id });

        this.model = null;
        this.year = null;
        this.generation = null;
      }
    },
    model() {
      if (this.model) {
        this.loadYears({ brand: this.brand?.id, model: this.model?.id });

        this.year = null;
        this.generation = null;
      }
    },
    year() {
      if (this.year) {
        this.loadGenerations({
          brand: this.brand?.id,
          model: this.model?.id,
          year: this.year?.id,
        });

        this.generation = null;
      }
    },
  },
  created() {
    this.loadBrands();
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addPopupData: 'Popups/addPopupData',
      loadBrands: 'Vikup/loadBrands',
      loadModels: 'Vikup/loadModels',
      loadYears: 'Vikup/loadYears',
      loadGenerations: 'Vikup/loadGenerations',
      loadBodies: 'Vikup/loadBodies',
    }),

    onSubmit(value, actions) {
      this.loadBodies({
        brand: this.brand.id,
        model: this.model.id,
        year: this.year.id,
        generation: this.generation.id,
        action: 'calculator-vikup',
      });

      this.togglePopup('calculator');
      this.addPopupData({
        brand: this.brand,
        model: this.model,
        year: this.year,
        generation: this.generation,
        subject: this.subject
      });

      this.brand = null;
      this.model = null;
      this.year = null;
      this.generation = null;
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <h2 class="title-h2 mb-6">{{ title }}</h2>
      <div class="p-6 border-2 border-green rounded-big-brand bg-white">
        <div>
          <img src="/public/images/logo.svg" alt="" class="w-full max-w-[186px] h-[41px] pr-2">
        </div>
        <p class="text-2xl text-gray-600 !mb-4">
          Заполните информацию
          <span class="text-green"> о&nbsp;автомобиле</span>
        </p>
        <vee-form
          :validation-schema="schema"
          novalidate
          class="grid grid-cols sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-4"
          @submit="onSubmit"
        >
          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="brand"
          >
            <v-select
              v-model="brand"
              :options="brands"
              label="text"
              placeholder="Выберите марку"
              inscription="Марка авто*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="model"
          >
            <v-select
              v-model="model"
              :options="models"
              label="text"
              :disabled="brand === null"
              placeholder="Выберите модель"
              inscription="Модель*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="year"
          >
            <v-select
              v-model="year"
              :options="years"
              label="text"
              :disabled="model === null"
              placeholder="Укажите год"
              inscription="Год*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="generation"
          >
            <v-select
              v-model="generation"
              :options="generations"
              label="text"
              :disabled="year === null"
              placeholder="Выберите поколение"
              inscription="Поколение*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <button
            type="submit"
            class="col-auto sm:col-start-1 sm:col-end-3 lg:col-start-2 lg:col-end-4 button button_green w-full text-base h-[48px]"
          >
            Получить честную оценку авто
          </button>
        </vee-form>
      </div>
    </div>
    <popup-calculator />
  </div>
</template>
